import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import {
  Card, Col, Form, Row, Alert,
} from 'react-bootstrap';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import { Link, Element } from 'react-scroll';
import {Link as RedirectLink} from 'react-router-dom'
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { makeUID, stepScroll, years } from '../../helpers';
import './styling.less';
import UniqueResultCard from './UniqueResultCard';
import UniqueResultCardpcVals from './UniqueResultCardpcVals';
import ReportStatusBadge from '../ReportStatusBadge';
import { statusKeys } from '../../helpers/projReportHelper';
import useUserContext from '../../hooks/useUserContext';
import useToast from '../../hooks/useToast';
import useAPI from '../../hooks/useAPI';
import Required from '../Required';
import { MonetaryFloatInput } from '../common/MonetaryFloatInput';

import YearSelect from '../common/YearSelect';

import { dateRenderer, floatRenderer } from '../../services/formatSvc';

import { getActionsModel } from '../../services/roles/projResultReportRoleStatus';
import ButtonsCardEdit from './ButtonsCardEdit';
import ReportMilestoneForm from "../project/Partials/ReportMilestoneForm";

export default function ReportYearEdit({
  projectId,
  permissions,
  role,
  year,
  changeYear,
  title,
}) {
  const [validated, setValidated] = useState(false);
  const [result, setResult] = useState(null);
  const [milestones, setMilestones] = useState([])
  const [proj, setProj] = useState({});
  const [status, setStatus] = useState(null);
  const [comment, setComment] = useState({});
  const [info, setInfo] = useState({});
  const [pcValFacts, setpcValFacts] = useState([]);
  const [projPlanFacts, setpcprojPlanFacts] = useState([]);
  const [finsources, setFinsources] = useState(null);
  const [decision, setDecision] = useState({
    isApproved: true,
    recommendations: undefined,
    protocol: undefined,
  });
  const [results, setResults] = useState([]);
  const [letters, setLetters] = useState([]);
  const [trls, setTrls] = useState([])

  const userCtx = useUserContext();
  const addToast = useToast();
  const api = useAPI();
  const history = useHistory();
  const location = useLocation();
  const {projId, stratId, portfolioId, policyId} = useParams()
  const can = useMemo(() => getActionsModel(status, userCtx, proj?.strategyId, proj?.originId, proj?.portfId, proj?.policyId), [status, proj]);

  const formEl = useRef(null);
  
  const getFileType = (f) => (f.link ? 'link' : 'file');

  const prepareResults = (results) =>
    results.map((r) => ({
      ...r,
      files: r.files.map((f) => ({
        ...f,
        hash: makeUID(5),
        type: getFileType(f),
      })),
    }));

  const reportLetter = useMemo(() => results.find((r) => r.isKey)?.letterCode, [results]);
  const themes = useMemo(
    () =>
      (proj.typeId === 3
        ? [
          'Естественные науки',
          'Технические науки',
          'Здравоохранение и медицинские науки',
          'Сельскохозяйственные науки',
          'Общественные науки',
          'Гуманитарные науки',
          'Оборона и безопасность государства',
          'Иное',
        ]
        : ['Оборона и безопасность государства', 'Иное']),
    [proj],
  );

  useEffect(async () => {
    setpcValFacts([]);
    setpcprojPlanFacts([]);
    setResult(null);
    setProj({});
    setStatus(null);
    setInfo({});
    setResults([]);
    setComment({});
    if (permissions.canRead) {
      const respResults = await api.get(`/projs/${projectId}/results?year=${year}`);
      if (respResults.error) return;
      if ([statusKeys.expertsApproved, statusKeys.expertsDeclined, statusKeys.approved].includes(respResults.status)) {
        switchToReadMode(); // если случайно оказались в редактировании утвержденного отчета, возвращаем в режим просмотра
      }

      const letters = await api.get('/mng/letters');
      const finSources = await api.get('/mng/finsources');
      const trls = await api.get('/mng/trls')
      const finSourcesByKeys = _.keyBy(finSources, 'type');
      setTrls(trls)
      setFinsources(finSourcesByKeys);
      setLetters(letters);
      setpcValFacts(respResults.pcVals.filter((e, i) => e?.values[0]?.year == year)); //
      setpcprojPlanFacts(respResults.plans.filter((e, i) => e.year == year)); //
      setResult(respResults); //
      setProj(respResults.proj);
      setStatus(respResults.status);
      setInfo(respResults.info);
      setResults(prepareResults(respResults.results));
      setMilestones(respResults.milestones)
      setComment({
        commentPortf: respResults.commentPortf,
        commentHead: respResults.commentHead,
        commentExpert: respResults.commentExpert,
      });
      const newResponseDecision = {
        isApproved: respResults.status !== statusKeys.notApproved,
        recommendations: respResults.expertGroupDecision,
        protocol: respResults.expertGroupProtocol,
      };
      setDecision(newResponseDecision);
    }
  }, [year]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    const isFormSavedSuccessfully = await handleFormSave();
    if (!isFormSavedSuccessfully) {
      addToast.error('Не было отправлено на Экспертную группу (не удалось сохранить)');
      return;
    }

    const isValid = event.target.checkValidity();
    if (!isValid) {
      addToast.error('Не было отправлено на Экспертную группу (обязательные поля не заполнены)');
      return;
    }

    const submitResponse = await api.post(`/projs/${projectId}/results/0/send`, { year });
    if (submitResponse.error) {
      addToast.error('При отправке на Экспертную группу произошла ошибка');
      return;
    }
    setStatus(submitResponse.status);
    addToast.info("Отчет отправлен на Экспертную группу");
  };

  const switchToReadMode = () => history.push(location.pathname);

  const handleResultChange = (id, field, newValue) => {
    if (field === 'isKey') {
      setResults((prevResults) =>
        prevResults.map((r) => (r.id === id ? { ...r, isKey: newValue } : { ...r, isKey: false })));
    } else setResults((prevResults) => prevResults.map((r) => (r.id === id ? { ...r, [field]: newValue } : r)));
  };

  const handlepcValFacts = async (value, field, index) => {
    setpcValFacts((prev) => {
      const arr = [...prev];
      arr[index].values[0][field] = value;
      return arr;
    });
  };

  const requestFileRemove = async (resId, fileId) => {
    await api.del(`/projs/${projectId}/results/${resId}/files/${fileId}`);
  };

  const requestFileRemove2 = async (resId, fileId) => {
    await api.del(`/projs/${projectId}/pcs/${resId}/files/${fileId}`);
  };

  const saveFormData = async () => {
    setValidated(true)
    if (formEl.current.checkValidity() === false) {
      const invalidEl = formEl.current.querySelector(':invalid');
      invalidEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
      invalidEl.focus()
      return;
    }

    const resultsToSubmit = results.map((r) => ({
      id: r.id,
      descr: r.descr,
      fact: r.fact,
      isKey: r.isKey,
      year: r.year,
    }));

    if(resultsToSubmit.some(result => !result.descr || (!result.fact && result.fact !== 0))){
      addToast.error('Заполните обязательные поля уникальных результатов.');
      return;
    }

    const filesToSubmit = results.reduce((acc, res) => {
      const filesToAdd = res.files
        .filter((f) => !f.id && ((f.type === 'link' && f.link) || (f.type === 'file' && f.file)))
        .map((f) => ({
          resultId: res.id,
          hash: f.hash,
          title: f.title,
          link: f.type === 'link' ? f.link : null, // todo
          file: f.type === 'file' ? f.file : null,
          type: f.type,
          year,
        }));
      return [...acc, ...filesToAdd];
    }, []);

    const filesToSubmit2 = [];

    pcValFacts.map((e) => {
      e.values[0]?.files.map((f) => {
        if (!f.id && ((f.type === 'link' && f.link) || (f.type === 'file' && f.doc))) {
          f.file = f.doc;
          filesToSubmit2.push(f);
        }
      });
    });

    if (filesToSubmit.some((f) => !f.title) || filesToSubmit2.some((f) => !f.title)) {
      addToast.error("Укажите название документа и попробуйте снова сохранить отчет");
      return false;
    }

    const respResults = await api.post(`/projs/${projectId}/results`, {
      year,
      info,
      facts: resultsToSubmit,
      pcValFacts: pcValFacts.map((e) => e.values[0] || {}),
      projPlanFacts: projPlanFacts.filter((e) => e.type === 'sf' && e.sfSourceId !== 4),
    });
    if (respResults.error) {
      return false;
    }

    for (const file of filesToSubmit2) {
      let fileLinkResult = null;
      switch (file.type) {
        case 'link':
          fileLinkResult = await api.post(`/projs/${projectId}/pcs/${file.projPcOriginId}/files`, {
            title: file.title,
            link: file.link,
            year,
            projPcOriginId: file.projPcOriginId,
            type: 'link',
          });
          break;
        case 'file':
          fileLinkResult = await api.postFormData(
            `/projs/${projectId}/pcs/${file.projPcOriginId}/files`,
            {
              title: file.title,
              year: file.year,
              projPcOriginId: file.projPcOriginId,
            },
            file.file,
          );
          break;
      }
      if (!fileLinkResult || fileLinkResult.error) {
        addToast.error(`При сохранении документа показателя "${file.title}" произошла ошибка`);
        return false;
      }
      await setpcValFacts((prevState) =>
        prevState.map((r) =>
          (r.values.find((v) => v.year === file.year)?.projPcOriginId === file.projPcOriginId
            ? {
              ...r,
              values: r.values.map((v) => (v.projPcOriginId === file.projPcOriginId
                ? {
                  ...v,
                  files: v.files.map((f) => (f.hash === file.hash ? { ...f, ...fileLinkResult } : f)),
                }
                : v)),
            }
            : r)));
    }

    for (const file of filesToSubmit) {
      let fileLinkResult = null;
      switch (file.type) {
        case 'link':
          fileLinkResult = await api.post(`/projs/${projectId}/results/${file.resultId}/files`, {
            title: file.title,
            link: file.link,
          });
          break;
        case 'file':
          fileLinkResult = await api.postFormData(
            `/projs/${projectId}/results/${file.resultId}/files`,
            { title: file.title },
            file.file,
          );
          break;
      }
      if (!fileLinkResult || fileLinkResult.error) {
        addToast.error(`При сохранении документа "${file.title}" произошла ошибка`);
        return false;
      }
      await setResults((prevState) =>
        prevState.map((r) =>
          (r.id === file.resultId
            ? {
              ...r,
              files: r.files.map((f) => (f.hash === file.hash ? { ...f, ...fileLinkResult } : f)),
            }
            : r)));
    }
    return true;
  };

  const handleInfoChange = async (value, field) => {
    setInfo((prev) => ({ ...prev, [field]: value }));
  };

  const handleprojPlanFacts = async (value, field, index) => {
    setpcprojPlanFacts((prev) => {
      const arr = [...prev];
      arr[index][field] = value;
      return arr;
    });
  };

  const actions = {
    onEdit: () => handleFormSave(),
    onRead: () => switchToReadMode(),
  };

  const handleFormSave = async () => {
    const isSavedSuccessfully = await saveFormData();
    if (isSavedSuccessfully) addToast.info('Отчет сохранен');
    return isSavedSuccessfully;
  };

  // const isFormValid = () => {
  //   if (formEl.current.checkValidity() === false) {
  //     const invalidEl = formEl.current.querySelector(':invalid');
  //     invalidEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
  //     invalidEl.focus()
  //     return false;
  //   } if (!results.find((r) => r.isKey)) {
  //     addToast.error('Необходимо указать ключевой уникальный результат');
  //     return false;
  //   }
  //   // if (results.find((r) => !r.files || r.files.length === 0)) {
  //   //   addToast.error('Необходимо приложить подтверждающий документ к каждому уникальному результату');
  //   //   return false;
  //   // }
  //   if (pcValFacts.find((r) => r.values.find((v) => !v.files || v.files.length === 0))&&!proj.portfId) {
  //     addToast.error('Необходимо приложить подтверждающий документ к каждому показателю');
  //     return false;
  //   } return true;
  // };

  if (!permissions.canRead) return <div style={{ color: 'red', background: 'white' }}>Недостаточно прав для просмотра страницы</div>;

  return (
    <section className="page unique-results" style={{ background: '#F5F5FF' }}>
      <nav className="step-scroll-box" style={{ marginBottom: '44px' }}>
        <Link to="Contents" {...stepScroll}>
          Содержание
        </Link>
        <Link to="Results" {...stepScroll}>
          Основные результаты
        </Link>
        <Link to="UniqueResults" {...stepScroll}>
          Уникальные результаты
        </Link>
        <Link to="Milestones" {...stepScroll}>
          Вехи проекта
        </Link>
        <Link to="Indicators" {...stepScroll}>
          Показатели
        </Link>
        <Link to="Achievements" {...stepScroll}>
          Достигнутые эффекты от реализации
        </Link>
        <Link to="Budget" {...stepScroll}>
          Бюджет
        </Link>
      </nav>
      <h3 style={styledHeading}>{`Ежегодный отчёт по проекту ${title}`}</h3>
      <div style={styledContainer}>
        <div style={styledCheckerContainer}>
          <YearSelect
            year={year}
            years={years}
            onChange={(e) => changeYear(e.value)}
          />
        </div>
        <div>
          <ReportStatusBadge status={status} />
        </div>
      </div>

      { comment?.commentPortf && (
      <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
        <strong>Комментарий руководителя портфеля</strong>
        <br />
        <br />
        {comment?.commentPortf}
      </Alert>
      ) }
      { comment?.commentHead && (
      <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
        <strong>Комментарий руководителя СП</strong>
        <br />
        <br />
        {comment?.commentHead}
      </Alert>
      ) }
      { comment?.commentExpert && (
      <Alert variant="danger" style={{ whiteSpace: 'pre-wrap' }}>
        <strong>Комментарий Проектного офиса</strong>
        <br />
        <br />
        {comment?.commentExpert}
      </Alert>
      ) }

      <Form validated={validated} onSubmit={handleSubmit} ref={formEl} style={{position:"relative"}}>
        {true && finsources && (
          <>
            <Element id="Contents" name="Contents">
              <Card className="mb-4">
                <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
                  Содержание
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="mb-4">
                    <Form.Group as={Col} md="3">
                      <Form.Label style={styledLabel}>Дата утверждения отчета</Form.Label>
                      <Form.Control
                        readOnly
                        as="input"
                        value={result?.approvedOn ? dateRenderer(result?.approvedOn) : ''}
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>
                        Тематика проекта
                        {/* <Required /> */}
                      </Form.Label>
                      <Form.Select
                        value={info.theme}
                        disabled={!can.Edit}
                        onChange={(e) => handleInfoChange(e.target.value, 'theme')}
                      >
                        <option value="" />
                        {themes?.map((t) => (
                          <option value={t} key={t}>
                            {t}
                          </option>
                        ))}
                      </Form.Select>
                      {/* <Form.Control.Feedback type="invalid">
                        Обязательное поле к заполнению
                      </Form.Control.Feedback> */}
                    </Form.Group>
                  </Row>
                  <h4 style={{ marginBottom: '20px', textAlign: 'left' }}>Цель</h4>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      {/* <Form.Label style={styledLabel}>План</Form.Label> */}
                      <Form.Control readOnly as="textarea" rows={3} value={proj.goal} />
                    </Form.Group>
                  </Row>
                  {/* <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>
                        Факт <Required />
                      </Form.Label>
                      <Form.Control
                        required
                        value={info.goalFact}
                        onChange={(e) =>
                          handleInfoChange(e.target.value, "goalFact")
                        }
                        as="textarea"
                        rows={3}
                        placeholder="Укажите описание достижения цели проекта за отчетный период"
                      />
                      <Form.Control.Feedback type="invalid">
                        Обязательное поле к заполнению
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row> */}
                  <h4 style={{ marginBottom: '20px', textAlign: 'left' }}>Задачи</h4>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>План</Form.Label>
                      <Form.Control readOnly as="textarea" rows={3} value={proj.tasks} />
                    </Form.Group>
                  </Row>
                  {/* <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>
                        Факт
                        <Required />
                      </Form.Label>
                      <Form.Control
                        value={info.tasksFact}
                        onChange={(e) =>
                          handleInfoChange(e.target.value, "tasksFact")
                        }
                        required
                        as="textarea"
                        rows={3}
                        placeholder="Укажите описание достижения задач проекта за отчетный период"
                      />
                      <Form.Control.Feedback type="invalid">
                        Обязательное поле
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row> */}
                  <Row className="mb-4">
                    {proj?.typeId === 3 && (
                      <Form.Group as={Col} md="6">
                        <Form.Label style={styledLabel}>
                          Регистрационный номер НИОКР
                          {' '}
                          <Required />
                          <Tooltip
                            title="Регистрационный номер НИОКР, присвоенный в системе ЕГИСУ НИОКТР"
                            placement="top-end"
                          >
                            <HelpOutlineIcon />
                          </Tooltip>
                        </Form.Label>
                        <Form.Control
                          required
                          readOnly={!can.Edit}
                          value={info.regNumber}
                          onChange={(e) => handleInfoChange(e.target.value, 'regNumber')}
                          placeholder="Номер должен состоять из чисел и символов (тире)"
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                      </Form.Group>
                    )}

                    <Form.Group as={Col} md="6">
                      <Form.Label style={styledLabel}>
                        Ссылка на связанный проект
                        {' '}
                        <Tooltip
                          title="Укажите ссылку на проект, если результаты вашего проекта зависят от другого проекта программы развития Приоритет 2030"
                          placement="top"
                        >
                          <HelpOutlineIcon />
                        </Tooltip>
                      </Form.Label>
                      <Form.Control
                        readOnly={!can.Edit}
                        value={info.linkedWork}
                        onChange={(e) => handleInfoChange(e.target.value, 'linkedWork')}
                        as="input"
                      />
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    <Col md={12}>
                      <Form.Label style={styledLabel} className="mb-2 text-muted" rows={3}>
                        Описание
                      </Form.Label>
                      <Form.Control readOnly value={proj.descr} as="textarea" />
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Element>

            <Element id="Results" name="Results">
              <Card className="mb-4">
                <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
                  Основные достигнутые результаты и проблемы, выявленные при реализации проекта в отчетном периоде
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>План</Form.Label>
                      <Form.Control value={proj?.result} as="textarea" rows={3} readOnly />
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    {proj?.portfId ? (
                      <>
                        <Form.Group className="mb-3" as={Col} md="12">
                          <Form.Label style={styledLabel}>
                            Фактически достигнутые научные результаты
                            {' '}
                            <Required />
                          </Form.Label>
                          <Form.Control
                            value={info.resultSciFact}
                            onChange={(e) => handleInfoChange(e.target.value, 'resultSciFact')}
                            required
                            as="textarea"
                            rows={3}
                            placeholder="Указать основные качественные научные результаты выполненной НИОКР за счет выделенного целевого
финансирования (без перечисления статей и т.п.). Дать оценку потенциалу и перспективам внедрения этих результатов на текущем этапе прикладных исследований. Описать также перспективы создания и внедрения новых технологий (сроки, партнеры, потребители,
привлеченные средства)."
                          />
                          <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                        </Form.Group>

                        {proj?.hasSciOrgResults && (
                          <Form.Group className="mb-3" as={Col} md="12">
                            <Form.Label style={styledLabel}>
                              Фактически достигнутые организационные результаты
                              {' '}
                              <Required />
                            </Form.Label>
                            <Form.Control
                              value={info.resultOrgFact}
                              onChange={(e) => handleInfoChange(e.target.value, 'resultOrgFact')}
                              required
                              as="textarea"
                              rows={3}
                              placeholder="Указать организационные результаты работы исследовательского коллектива в отчетном году. Например, отметить, какие произошли изменения в коллективе, в организации работы, сколько молодых исследователей привлечено. Как развивались партнерские отношения, в том числе с предприятиями реального сектора экономики."
                            />
                            <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                          </Form.Group>
                        )}
                      </>
                    ) : (
                      <Form.Group className="mb-3" as={Col} md="12">
                        <Form.Label style={styledLabel}>
                          Факт
                          {' '}
                          <Required />
                        </Form.Label>
                        <Form.Control
                          value={info.resultFact}
                          onChange={(e) => handleInfoChange(e.target.value, 'resultFact')}
                          required
                          as="textarea"
                          rows={3}
                          placeholder="Укажите описание достижения итогового результата проекта (продукта) за отчетный период"
                        />
                        <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                      </Form.Group>
                    )}
                    <Form.Group className="mb-3" as={Col} md="12">
                      <Form.Label style={styledLabel}>Проблемы, выявленные при реализации проекта</Form.Label>
                      <Form.Control
                        value={info.problems}
                        onChange={(e) => handleInfoChange(e.target.value, 'problems')}
                        as="textarea"
                        rows={3}
                        placeholder="Укажите проблемы, выявленные при реализации проекта за отчетный период."
                      />
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Element>

            <Element id="UniqueResults" name="UniqueResults">
              <Card className="mb-4">
                <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
                  Уникальные результаты проекта
                </Card.Header>
                <Card.Body className="p-4">
                  {results.map((r) => (
                    <UniqueResultCard
                      portfId={proj?.portfId}
                      letters={letters}
                      data={r}
                      key={r.id}
                      onResultChange={handleResultChange}
                      requestFileRemove={requestFileRemove}
                      canEdit={can.Edit}
                    />
                  ))}
                </Card.Body>
              </Card>
            </Element>

            <Element id='Milestones' name='Milestones'>
              <Card className='mb-4'>
                <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
                  Вехи проекта
                </Card.Header>
                <Card.Body>
                  <Alert className='mb-4' style={{backgroundColor: '#ffecb5', color: '#664d03', border: 'none'}}>
                    Для заполнения вех по проекту перейдите на страницу
                    {' '}
                    <RedirectLink to={!!stratId ? `/strats/${stratId}${portfolioId ? `/portfolios/${portfolioId}/projs/${projId}` : `/projs/${projId}`}/report/milestones` : `/policies/${policyId}/projs/${projId}/report/milestones`}>
                      «Вехи проекта»
                    </RedirectLink>
                  </Alert>
                  {milestones.map((milestone, i) => <Card className='mb-4' key={i}>
                    <Card.Header className='p-3'>Веха {i + 1}</Card.Header>
                    <Card.Body>
                      <ReportMilestoneForm readonly milestone={milestone} trls={trls}/>
                    </Card.Body>
                  </Card>)}
                </Card.Body>
              </Card>
            </Element>

            <Element id="Indicators" name="Indicators">
              <Card className="mb-4">
                <Card.Header className="p-4" style={{ backgroundColor: cardHeaderColor }}>
                  Показатели проекта
                </Card.Header>
                <Card.Body className="p-4">
                  {result?.pcVals
                    ?.filter((e) => e?.values[0]?.plan)
                    .map((e, i) => (
                      <Card key={i} className="mb-4">
                        <Card.Header className="p-4" />
                        <Card.Body className="p-4">
                          <Row className="mb-4">
                            <Form.Group as={Col} md="12">
                              <Form.Label style={styledLabel}>Наименование показателя</Form.Label>
                              <Form.Control value={e.name} as="textarea" rows={3} readOnly />
                            </Form.Group>
                          </Row>
                          <Row className="mb-4">
                            <Form.Group as={Col} md="3">
                              <Form.Label style={styledLabel}>Единицы измерения</Form.Label>
                              <Form.Control value={e.unit} readOnly as="input" />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                              <Form.Label style={styledLabel}>Ключевой показатель</Form.Label>
                              <Form.Control value={e.isKey ? 'Да' : 'Нет'} readOnly as="input" />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                              <Form.Label style={styledLabel}>План</Form.Label>
                              <Form.Control value={e?.values[0]?.plan} readOnly as="input" />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                              <Form.Label style={styledLabel}>
                                Факт
                                {' '}
                                <Required />
                              </Form.Label>
                              <Form.Control
                                readOnly={e.readonly}
                                onChange={(e) => {
                                  handlepcValFacts(e.target.value, 'fact', i);
                                }}
                                value={pcValFacts[i].values[0]?.fact}
                                required
                                as="input"
                                type={!!e.fixedPcId || e.fixedPcId === 0 ? 'number' : 'text'}
                              />
                              <Form.Control.Feedback type="invalid">
                                Обязательное поле к заполнению
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Row>
                          <UniqueResultCardpcVals
                            portfId={proj?.portfId}
                            year={year}
                            name={e.name}
                            projPcOriginId={pcValFacts[i]?.values[0]?.projPcOriginId}
                            requestFileRemove={requestFileRemove2}
                            data={pcValFacts[i].values[0]?.files}
                            canEdit={can.Edit} // to do
                            onResultChange={(files) => handlepcValFacts(files, 'files', i)}
                          />
                        </Card.Body>
                      </Card>
                    ))}
                </Card.Body>
              </Card>
            </Element>

            <Element id="Achievements" name="Achievements">
              <Card className="mb-4">
                <Card.Header
                  // as={Card.Title}
                  className="p-4"
                  style={{ backgroundColor: cardHeaderColor }}
                >
                  Достигнутые эффекты от реализации проекта
                </Card.Header>
                <Card.Body className="p-4">
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>
                        Эффект на университетском уровне
                        {' '}
                        <Required />
                      </Form.Label>
                      <Form.Control
                        readOnly={!can.Edit}
                        value={info.uniEffect || ''}
                        onChange={(e) => handleInfoChange(e.target.value, 'uniEffect')}
                        required
                        as="textarea"
                        rows={3}
                        placeholder="Опишите результат на университетском уровне"
                      />
                      <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>
                        Эффект на региональном и(или) отраслевом уровне
                        {' '}
                        <Required />
                      </Form.Label>
                      <Form.Control
                        readOnly={!can.Edit}
                        value={info.regionEffect || ''}
                        onChange={(e) => handleInfoChange(e.target.value, 'regionEffect')}
                        required
                        as="textarea"
                        rows={3}
                        placeholder="Опишите результат на региональном и(или) отраслевом уровне"
                      />
                      <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <Row className="mb-4">
                    <Form.Group as={Col} md="12">
                      <Form.Label style={styledLabel}>
                        Эффект на национальном уровне
                        {' '}
                        <Required />
                      </Form.Label>
                      <Form.Control
                        readOnly={!can.Edit}
                        value={info.countryEffect || ''}
                        onChange={(e) => handleInfoChange(e.target.value, 'countryEffect')}
                        required
                        as="textarea"
                        rows={3}
                        placeholder="Опишите результат на национальном уровне"
                      />
                      <Form.Control.Feedback type="invalid">Обязательное поле к заполнению</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Card.Body>
              </Card>
            </Element>

            <Element id="Budget" name="Budget">
              <Card className="mb-4">
                <Card.Header className="p-4">Бюджет</Card.Header>
                <Card.Body className="p-4">
                  {result?.plans
                    ?.filter((e) => e.year == year)
                    .map((e, i) => (
                      <Card key={i} className="mb-4">
                        <Card.Header className="p-4" />
                        <Card.Body className="p-4">
                          <h4
                            style={{
                              marginBottom: '20px',
                              textAlign: 'left',
                            }}
                          >
                            {e.type === 'fb' ? 'Грант' : 'Софинансирование'}
                          </h4>

                          {e.type === 'fb' && (
                          <Row className="mb-4">
                            <Form.Group as={Col} md="2">
                              <Form.Label style={styledLabel}>Год</Form.Label>
                              <Form.Control value={e.year} readOnly as="input" />
                            </Form.Group>
                            <Form.Group as={Col} md="7">
                              <Form.Label style={styledLabel}>Соглашение</Form.Label>
                              <Form.Control
                                value={
                                      finsources.fb.sources.agreements.filter((a) => a.id == e.agreementId)[0].name
                                    }
                                readOnly
                                as="input"
                              />
                            </Form.Group>
                            <Form.Group as={Col} md="3">
                              <Form.Label style={styledLabel}>Код подраздела БК</Form.Label>
                              <Form.Control
                                value={finsources.fb.sources.bcCodes.filter((a) => a.id == e.bcCodeId)[0].fullCode}
                                readOnly
                                as="input"
                              />
                            </Form.Group>
                          </Row>
                          )}

                          {e.type === 'sf' && (
                          <Row className="mb-4">
                            <Form.Group as={Col} md="2">
                              <Form.Label style={styledLabel}>Год</Form.Label>
                              <Form.Control value={e.year} readOnly as="input" />
                            </Form.Group>
                            <Form.Group as={Col} md="10">
                              <Form.Label style={styledLabel}>Источник</Form.Label>
                              <Form.Control
                                value={finsources.sf.sources.sf.filter((a) => a.id == e.sfSourceId)[0]?.name}
                                readOnly
                                as="input"
                              />
                            </Form.Group>
                          </Row>
                          )}
                          <Row className="mb-4">
                            <Form.Group as={Col} md="4">
                              <Form.Label style={styledLabel}>
                                {e.type === 'fb' ? 'Тип финансирования' : 'Тип софинансирования'}
                              </Form.Label>
                              <Form.Control
                                value={finsources[e.type].sources.funding.filter((a) => a.id == e.fundingId)[0]?.name}
                                readOnly
                                as="input"
                              />
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                              <Form.Label style={styledLabel}>План, руб.</Form.Label>
                              <Form.Control value={floatRenderer(e.sum)} readOnly as="input" />
                            </Form.Group>
                            <Form.Group as={Col} md="4">
                              <Form.Label style={styledLabel}>
                                Факт, руб.
                                {' '}
                                {!(e.type === 'fb' || e.sfSourceId == 4) && <Required />}
                              </Form.Label>
                              <MonetaryFloatInput
                                required={!(e.type === "fb" || e.sfSourceId == 4)}
                                disabled={e.type === "fb" || e.sfSourceId == 4}
                                onChange={(e) => {
                                  handleprojPlanFacts(e, "paymentSum", i);
                                }}
                                value={projPlanFacts[i]?.paymentSum}
                                as="input"
                              ></MonetaryFloatInput>
                              <Form.Control.Feedback type="invalid">
                                Обязательное поле к заполнению
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Row>
                        </Card.Body>
                      </Card>
                    ))}
                </Card.Body>
              </Card>
            </Element>
          </>
        )}
        <div style={{position:"sticky", bottom:"0", zIndex:"100"}}>
          <ButtonsCardEdit
          can={can}
          actions={actions}
        /></div>
      </Form>
    </section>
  );
}

const styledContainer = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '18px',
};
const styledCheckerContainer = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
};
const cardHeaderColor = '#F7F7F7';
const styledHeading = { marginBottom: 34, textAlign: 'left' };

const styledLabel = { color: '#7F7F7F', fontWeight: '600' };
